/**
 * ClockIcon Component
 * Clock icon for duration/time display (e.g. table header).
 */

import React from 'react';
import type { IconProps } from './types';
import { colors } from '../colors';

const defaultColor = colors.neutral.white;

const ClockIcon: React.FC<IconProps> = ({
  size = 16,
  color = defaultColor,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.667 8A6.67 6.67 0 018 14.667 6.67 6.67 0 011.333 8 6.67 6.67 0 018 1.333 6.67 6.67 0 0114.667 8z"
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.473 10.12L8.407 8.887c-.36-.214-.654-.727-.654-1.147V5.007"
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ClockIcon;
